import useIndividualExposures from '../../../hooks/useIndividualExposures';
import React from 'react';
import { Table } from '../../Table';
import { TableSubTitle, TableTitle, TableStyle } from './style';
import { TableComponentProps } from '../types';
import { idCreator } from '../../../../../Project/utils/idCreator';

export function IndividualExposures({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const { onChange: onChange, tables } = useIndividualExposures({
    data: funds[currentDataKey]?.fund_data.INDIVIDUAL_EXPOSURES,
    onChangeFund,
    schema: schema.INDIVIDUAL_EXPOSURES,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.INDIVIDUAL_EXPOSURES?.field_names || [],
    funds,
    isMultiFunds
  });

  return tables.map(item => (
    <React.Fragment key={item.name}>
      <TableTitle id={`reporttables-individual-exposures-title-${idCreator(item.name)}`}>
        {item.name}:
      </TableTitle>
      {item.tables.map(value => (
        <React.Fragment key={value.name}>
          <TableSubTitle id={`reporttables-individual-exposures-subtitle-${idCreator(value.name)}`}>
            {value.name}
          </TableSubTitle>
          <TableStyle id={`reporttables-individual-exposures-group-${idCreator(value.name)}`}>
            {value.tables.map((table, index) => (
              <div
                className="table-item"
                id={`reporttables-individual-exposures-table-item-${idCreator(value.name)}-${index + 1}`}
                key={index}
              >
                <Table
                  id={`reporttables-individual-exposures-table-${idCreator(value.name)}-${index + 1}`}
                  handleChanges={onChange}
                  columns={table.columns}
                  // @ts-ignore
                  rows={table.rows}
                  key={`${value.name}-${index}`}
                  stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
                />
              </div>
            ))}
          </TableStyle>
        </React.Fragment>
      ))}
    </React.Fragment>
  ));
}
